import { render } from "./DefaultDevicesSlot.vue?vue&type=template&id=f3588ef0&scoped=true"
import script from "./DefaultDevicesSlot.vue?vue&type=script&lang=js"
export * from "./DefaultDevicesSlot.vue?vue&type=script&lang=js"

import "./DefaultDevicesSlot.vue?vue&type=style&index=0&id=f3588ef0&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3588ef0"]])

export default __exports__